import { type ConnectedProps } from "react-redux";
import { type Action } from "redux";
import { type ThunkAction } from "redux-thunk";
import { type ShopfrontDispatch } from "../../_Bootstrap/hooks";
import { type RootState } from "../../Reducers/ShopfrontReducers";

export function fireEventType<T extends string>(type: T): Action<T> {
    return {
        type: type,
    };
}

export type ShopfrontActions<T> = T;

export type ShopfrontThunk<
    DispatchAction extends Action = Action<string>,
    ReturnType = void
> = ThunkAction<ReturnType, RootState, unknown, DispatchAction>;

export type ConnectedShopfront<T> = ConnectedProps<T> & {
    dispatch: ShopfrontDispatch;
};
